module.exports = __webpack_public_path__ + "static/3-d13158a5c75608bc913113a90fc39a48.jpg";